import styled from 'styled-components';
import React from 'react';

// path from 'assets/svg/navigation/icon_exit.svg';

const icon = (
  // eslint-disable-next-line
  <path className="icon" fill="#F9A303" stroke="#FFFFFF" strokeWidth="2.4" d="M9.89684699,19.32 L12.7897306,2.4 L23.2102694,2.4 L26.103153,19.32 L37.156417,19.32 L18,33.9083484 L-1.15641705,19.32 L9.89684699,19.32 Z"></path>
);

const SVGIcon = styled.svg.attrs({
  viewBox: '0 0 36 36',
})`
  height: calc(100vh * 2.5 / 100);
  min-height: 2.25rem;
  width: auto;
  margin-top: calc(100vh * 0.1/ 100);
  transform: ${(props) => (props.up && 'rotate(-180deg)')};
`;

export default (props) => <SVGIcon {...props}>{icon}</SVGIcon>;



// WEBPACK FOOTER //
// ./src/components/SwitchViewButton/ExitIcon.js